import { render, staticRenderFns } from "./WaterLeakageCauseFixedQuestion.vue?vue&type=template&id=a42a89a6&scoped=true"
import script from "./WaterLeakageCauseFixedQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageCauseFixedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42a89a6",
  null
  
)

export default component.exports